export enum FileType {
    Document = 'document',
    Image = 'image',
    Link = 'link'
}

export const isImage = (file: File | Blob) => {
    return file.type.includes('image');
};

export const isPdf = (file: File | Blob) => {
    return file.type === 'application/pdf';
};

export const isDocument = (file: File | Blob) => {
    return (
        file.type.includes('text') ||
        file.type.includes('application') ||
        file.type.includes('font')
    );
};

export const isTextFile = (file: File | Blob) => {
    return file.type.includes('text');
};

export const isAudio = (file: File | Blob) => {
    return file.type.includes('audio');
};

export const isVideo = (file: File | Blob) => {
    return file.type.includes('video');
};

export const isLink = (data: File | Blob | string): data is string => {
    return typeof data === 'string';
};

export const isFile = (input: any): input is File => {
    return (
        typeof input === 'object' &&
        'lastModified' in input &&
        'name' in input &&
        'webkitRelativePath' in input &&
        'prototype' in input
    );
};
